
import { mapActions } from "vuex";
import { APP_STORE_PAGE_VISITED } from "@/constants/MixpanelEvents.js";
export default {
  components: {
    appsHeaderRow: () => import("@/components/apps/apps-header-row.vue"),
    AppsMyApps: () => import("@/components/apps/apps-my-apps.vue"),
    AppsRecommendedForYou: () =>
      import("@/components/apps/apps-recommended-for-you.vue"),
    AppsSystemDefaultApps: () =>
      import("@/components/apps/apps-system-default-apps.vue")
  },
  async beforeMount() {
    this.appsLoading = true;
    await this.fetchApps();
    this.appsLoading = false;
  },
  mounted() {
    this.mixPanelTrackEvent(APP_STORE_PAGE_VISITED);
  },
  data() {
    return {
      appsLoading: false
    };
  },
  methods: {
    ...mapActions("apps", ["fetchApps"])
  }
};
